import { ENVIRONMENTS } from '../constants/environments';

export const MARKETING_QUERY_PARAMS = {
	clickId: 'clickid',
};

export const FRIEND_INVITE_QUERY_PARAMS = {
	friendInvite: 'invitation',
};

export const hasQueryString = (url) => /\?/.test(url);

export function getSubdomain() {
	const host = window.location.host;
	const subdomain = ENVIRONMENT === ENVIRONMENTS.DEVELOPMENT
		? 'am'
		: host.split('-')[0];

	return  subdomain;
}

export function getDomain() {
	let domain = window.location.host;

	if (ENVIRONMENT === ENVIRONMENTS.DEVELOPMENT) {
		domain = 'localhost';
	}

	else if ((domain.match(/\./g) || []).length == 2) {
		domain = domain.substring(domain.indexOf('.') + 1);
	}

	return domain;
}

export function getQueryParam(paramName) {
	const queryString = window.location.search;

	if (!queryString) {
		return null;
	}

	const searchParams = new URLSearchParams(queryString);

	if (!searchParams) {
		return null;
	}

	const paramValue = searchParams.get(paramName);

	return paramValue || null;
}

export function addQueryParams(baseUrl, keyValuePairs) {
	try {
		if (!keyValuePairs || Object.keys(keyValuePairs).length === 0) {
			return new URL(baseUrl).toString();
		}
		
		const url = new URL(baseUrl);

		for (const [key, value] of Object.entries(keyValuePairs)) {
			if (value) {
				url.searchParams.set(key, value);
			} else {
				continue;
			}
		}
	
		return url.toString();
	} catch (error) {
		return false;
	}
}

export function changeQueryParam(baseUrl, paramName, newValue) {
	try {
		const url = new URL(baseUrl);

		if (newValue) {
			url.searchParams.set(paramName, newValue);
		} else {
			url.searchParams.delete(paramName);
		}

		return url.toString();
	} catch (error) {
		return false;
	}
}

export function hasQueryParam(paramName) {
	const queryParam = getQueryParam(paramName);
	return queryParam ? true : false;
}

export function isQueryParamEqualTo(paramName, value) {
	const urlParamValue = getQueryParam(paramName);

	if (!urlParamValue) {
		return false;
	}

	return urlParamValue === value;
}

export function getAllQueryParams() {
	const queryString = window.location.search;
	const searchParams = new URLSearchParams(queryString);
	const parameters = {};

	for (const [key, value] of searchParams.entries()) {
		parameters[key] = value;
	}

	if (Object.keys(parameters).length < 1) {
		return null;
	}
	
	return parameters;
}
